module.exports = __webpack_public_path__ + "static/kanbanist-e9b1ac14e2bed2130bc12e6d6b1a0752.svg";